import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-content mb-10 mt-n1\"><div class=\"pe-3 mb-5\"><div class=\"fs-5 fw-bold mb-2\"> Task <a href=\"#\" class=\"text-primary fw-bolder me-1\">#45890</a> merged with <a href=\"#\" class=\"text-primary fw-bolder me-1\">#45890</a> in “Ads Pro Admin Dashboard project: </div><div class=\"d-flex align-items-center mt-1 fs-6\"><div class=\"text-muted me-2 fs-7\">Initiated at 4:23 PM by</div><div class=\"symbol symbol-circle symbol-25px\" data-bs-toggle=\"tooltip\" data-bs-boundary=\"window\" data-bs-placement=\"top\" title=\"Nina Nilson\"><img src=\"media/avatars/150-11.jpg\" alt=\"img\"></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs027.svg" })
        ])
      ])
    ]),
    _hoisted_6
  ]))
}